import {getUserConfig, getWeekDay} from "@utility/utils";

const data = getWeekDay(0)

const initialState = {
    list: [],
    total: 0,
    loading: false,
    searchParams: {
        clubNo: "",
        club_name: "",
        avatar_url: "",
        player_user_id: "",
        edit_type: "-1,1,2,3,4,5,6,7,8,10,11,13,14,r15,17",
        start_date: data[0],
        end_date: data[1],
        page: 1,
        count: 30,
        refresh: false,
        ...getUserConfig("clubChangeRecord")
    }
}

const changeRecord = (state = initialState, action) => {
    switch (action.type) {
        case 'CLUB_CHANGE_RECORD':
            return {
                ...state,
                ...action.payload
            }
        case 'CLUB_CHANGE_RECORD_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams, ...getUserConfig("clubChangeRecord")
                },
            }
        default:
            return {...state};
    }
}

export default changeRecord
